(function () {
    'use strict';

    angular
        .module('app.user')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'pendingUserService', '$rootScope'];

    /* @ngInject */
    function appRun(routerHelper, pendingUserService, $rootScope) {
        var pendingBadge = document.createElement('span');       
        pendingBadge.className = 'badge notify';       

        $rootScope.$on('updatePendingUsersBadgeCount', function (ev, count) {
            pendingBadge.innerHTML = count > 0 ? count : '';
            var element = document.getElementsByClassName('pendingusers')[0];
            if (element) {
                element.appendChild(pendingBadge);
            }
        });

        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'user.pending',
                config: {
                    url: '/pending-users',
                    templateUrl: 'app/user/pending/user.pending.html',
                    controller: 'PendingUserController',
                    controllerAs: 'vm',
                    title: 'Pending Users Dashboard',                   
                    settings: {
                        isVisible: true,
                        nav: 4,
                        content: '<i class="fa fa-users pendingusers"></i> Pending Users'
                    },
                    data: {
                        permissions: {
                            only: [''],
                            redirectTo: function () {
                                return {
                                    state: 'error.403',
                                    options: {
                                        reload: true
                                    }
                                };
                            }
                        }
                    }
                }
            }
        ];
    }
})();
